"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = exports.TestTabs = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.map");

var _classnames = _interopRequireDefault(require("classnames"));

var _object = _interopRequireDefault(require("object.omit"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _safeMapAndCloneChildren = _interopRequireDefault(require("../utils/safeMapAndCloneChildren"));

var _TabsPanel = _interopRequireDefault(require("./TabsPanel"));

var _withId = _interopRequireDefault(require("../utils/withId"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var TAB_PAGE_SIZE = 250;
var OFFSET_ADJUST = 96;
var propTypes = {
  activeKey: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(['center', 'left', 'justify']),
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  pagination: _propTypes["default"].bool
};
var defaultProps = {
  activeKey: undefined,
  align: 'center',
  children: undefined,
  className: undefined,
  id: '',
  onChange: function onChange() {},
  pagination: true
};

var Tabs = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tabs, _Component);

  function Tabs(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.tabHeader = /*#__PURE__*/_react["default"].createRef();
    _this.tabList = /*#__PURE__*/_react["default"].createRef();
    _this.activeTab = /*#__PURE__*/_react["default"].createRef();

    _this.getTabHeaderOffset = function () {
      return _this.tabHeader.current ? _this.tabHeader.current.scrollWidth - _this.tabList.current.scrollWidth : 0;
    };

    _this.calculateAndSetMaxTranslation = function () {
      var offset = _this.getTabHeaderOffset();

      _this.setState({
        maxTranslation: offset - OFFSET_ADJUST
      });
    };

    _this.determinePagination = function () {
      var paginationEnabled = _this.state.paginationEnabled;

      var offset = _this.getTabHeaderOffset();

      if (offset < 0 && !paginationEnabled) {
        _this.setState({
          paginationEnabled: true
        });
      }

      if (offset >= 0 && paginationEnabled) {
        _this.setState({
          paginationEnabled: false,
          tabsTranslation: 0
        });
      }

      _this.calculateAndSetMaxTranslation();
    };

    _this.handlePaginate = function (direction) {
      _this.calculateAndSetMaxTranslation();

      var _this$state = _this.state,
          maxTranslation = _this$state.maxTranslation,
          tabsTranslation = _this$state.tabsTranslation;
      var trans = tabsTranslation;

      if (direction === 'left') {
        trans = tabsTranslation + TAB_PAGE_SIZE;
        trans = trans > 0 ? 0 : trans;
      }

      if (direction === 'right') {
        trans = tabsTranslation - TAB_PAGE_SIZE;

        if (trans < maxTranslation) {
          trans = maxTranslation;
        }
      }

      _this.setState({
        tabsTranslation: trans
      });
    };

    _this.handleChange = function (event, clickedKey) {
      var onChange = _this.props.onChange;
      onChange(clickedKey, event);

      _this.setState({
        activeKey: clickedKey
      });
    };

    _this.getArrowDisabled = function (direction) {
      var _this$state2 = _this.state,
          maxTranslation = _this$state2.maxTranslation,
          tabsTranslation = _this$state2.tabsTranslation;

      if (direction === 'left') {
        return tabsTranslation === 0;
      }

      return tabsTranslation <= maxTranslation;
    };

    _this.getFirstKey = function () {
      var children = _this.props.children;
      if (!children) return null;
      return _react["default"].Children.map(children, function (child) {
        return child.key;
      })[0];
    };

    _this.getTabClasses = function (_ref) {
      var _ref$props = _ref.props,
          active = _ref$props.active,
          disabled = _ref$props.disabled;
      return (0, _classnames["default"])('grv-tabpanel__tab', {
        'grv-tabpanel__tab--active': active
      }, {
        'grv-tabpanel__tab--disabled': disabled
      });
    };

    _this.getTabButtonClasses = function (direction, shouldPaginate) {
      return (0, _classnames["default"])('grv-tabpanel__arrow', "grv-tabpanel__arrow--" + direction, {
        'grv-hidden': !shouldPaginate
      });
    };

    var activeKey = _this.props.activeKey;
    _this.state = {
      activeKey: activeKey,
      maxTranslation: 0,
      paginationEnabled: false,
      tabsTranslation: 0
    };
    return _this;
  }

  var _proto = Tabs.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.determinePagination);
    this.determinePagination();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.determinePagination);
  };

  _proto.handleKeyDown = function handleKeyDown(e, key) {
    var _this2 = this;

    var children = this.props.children;
    var keys = children.map(function (child) {
      return child.key;
    });
    var nextKey;

    if (e.keyCode === 37) {
      // Arrow Left
      nextKey = keys[keys.indexOf(key) - 1];
    } else if (e.keyCode === 39) {
      // Arrow Right
      nextKey = keys[keys.indexOf(key) + 1];
    }

    if (nextKey) {
      this.setState({
        activeKey: nextKey
      }, function () {
        return _this2.activeTab.current && _this2.activeTab.current.focus();
      });
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        propsActiveKey = _this$props.activeKey,
        align = _this$props.align,
        children = _this$props.children,
        className = _this$props.className,
        id = _this$props.id,
        propsPaginationEnabled = _this$props.pagination,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["activeKey", "align", "children", "className", "id", "pagination"]);

    var _this$state3 = this.state,
        stateActiveKey = _this$state3.activeKey,
        paginationEnabled = _this$state3.paginationEnabled,
        tabsTranslation = _this$state3.tabsTranslation;
    var shouldClearActiveItem = propsActiveKey === null;
    var activeKey = shouldClearActiveItem ? null : stateActiveKey || propsActiveKey || this.getFirstKey();
    var childrenWithProps = children ? (0, _safeMapAndCloneChildren["default"])(children, function (child) {
      return {
        active: activeKey === child.key,
        'aria-labelledby': id + "__" + child.key + "-tab",
        id: id + "__" + child.key + "-panel",
        onKeyDown: function onKeyDown(event) {
          return _this3.handleKeyDown(event, child.key);
        },
        onTabClick: function onTabClick(event) {
          return _this3.handleChange(event, child.key);
        },
        tabIndex: 0
      };
    }) : []; // TODO - Is this safe if children are strings and stuff?

    var childrenWithCleanProps = childrenWithProps.map(function (child) {
      return Object.assign({}, child, {
        props: (0, _object["default"])(child.props, ['onTabClick', 'onKeyDown'])
      });
    });
    var shouldPaginate = paginationEnabled && propsPaginationEnabled;
    var tabPanelClasses = (0, _classnames["default"])(className, 'grv-tabpanel');
    var tabListClasses = (0, _classnames["default"])('grv-tabpanel__tablist', {
      'grv-tabpanel__tablist--center': align === 'center' && !shouldPaginate
    }, {
      'grv-tabpanel__tablist--align-left': align === 'left' && !shouldPaginate
    }, {
      'grv-tabpanel__tablist--align-justify': align === 'justify' && !shouldPaginate
    });
    var tabListStyle = {
      transform: "translateX(" + tabsTranslation + "px)"
    };
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: tabPanelClasses,
      id: id
    }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-tabpanel__header",
      ref: this.tabHeader
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      className: this.getTabButtonClasses('left', shouldPaginate),
      disabled: this.getArrowDisabled('left'),
      onClick: function onClick() {
        return _this3.handlePaginate('left');
      },
      type: "button"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "grv-tabpanel__tablist-container",
      ref: this.tabList
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: tabListClasses,
      role: "tablist",
      style: tabListStyle
    }, childrenWithProps.map(function (tab) {
      return /*#__PURE__*/_react["default"].createElement("button", {
        "aria-controls": tab.props.id,
        "aria-selected": tab.props.active,
        className: _this3.getTabClasses(tab),
        disabled: tab.props.disabled,
        id: tab.props['aria-labelledby'],
        key: tab.key,
        onClick: tab.props.onTabClick,
        onKeyDown: tab.props.onKeyDown,
        ref: tab.props.active ? _this3.activeTab : null,
        role: "tab",
        tabIndex: tab.props.active ? 0 : -1,
        type: "button"
      }, tab.props.title);
    }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
      className: this.getTabButtonClasses('right', shouldPaginate),
      disabled: this.getArrowDisabled('right'),
      onClick: function onClick() {
        return _this3.handlePaginate('right');
      },
      type: "button"
    }))), childrenWithCleanProps);
  };

  return Tabs;
}(_react.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Tabs.Panel = _TabsPanel["default"];
var TestTabs = Tabs;
exports.TestTabs = TestTabs;
var TabsWithId = (0, _withId["default"])(Tabs);
TabsWithId['Panel'] = _TabsPanel["default"];
var _default = TabsWithId;
exports["default"] = _default;